import { render } from "./TokenOverview.vue?vue&type=template&id=1f9acc08&scoped=true"
import script from "./TokenOverview.vue?vue&type=script&lang=js"
export * from "./TokenOverview.vue?vue&type=script&lang=js"

import "./TokenOverview.vue?vue&type=style&index=0&id=1f9acc08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9acc08"]])

export default __exports__